const smoothScrollToAnchor = (header) => {
  header.addEventListener('click', e => {
    e.preventDefault();

    let anc = e.target.getAttribute('href') || null;
    if (!anc) return;
    let headerHeight = parseInt(window.getComputedStyle(document.querySelector('.header')).height);
    let yOffset = parseInt(`-${headerHeight + 20}`);
    let elToScroll = document.querySelector(anc) || null;

    if (elToScroll) {
      let y = elToScroll.getBoundingClientRect().top + window.pageYOffset + yOffset;

      if (anc === '#taste') {
        let sectTaste = document.querySelector('#taste');
        let tastePaddingTop = parseInt(window.getComputedStyle(sectTaste).paddingTop);
        y = sectTaste.offsetTop + (tastePaddingTop - headerHeight - 20);
      }

      header.classList.remove('toggled');
      document.body.classList.remove('overflow');
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    } else {
      window.location.href = window.location.origin + anc;
    }
  });
}

export default smoothScrollToAnchor;